import React from "react";
import { Paragraph, TextWrapper, ContentfulParagraph } from "./style";
import titlebBaseImage from "../../../assets/images/title-base.png";
import {
  HeadingStyle,
  ImageTitle,
  TitleWrapper,
} from "../../TitleBase/style";

interface DonationPagesDescriptionProps {
  title: string;
  content: string[];
  contentfulFormat?: boolean;
}

export const DonationPagesDescription: React.FC<
  DonationPagesDescriptionProps
> = ({
  title,
  content,
  contentfulFormat = false,
}) => {
  return (
    <div>
      <TextWrapper>
        <TitleWrapper>
          <HeadingStyle>
            <p>{title}</p>
          </HeadingStyle>

          <ImageTitle
            src={titlebBaseImage}
            alt="Title Image"
          />
        </TitleWrapper>

        {contentfulFormat ? (
          <ContentfulParagraph>
          {content.map((line, index) => {
            if (line.trim() === "") {
              return (
                <div key={`space-${index}`} className="paragraph-space" />
              );
            }
        
            return (
              <div key={`${line}-${index}`} className="content-line">
                {line}
              </div>
            );
          })}
        </ContentfulParagraph>
        ) : (
          <Paragraph>
            {content.map((paragraph) => (
            <p key={paragraph}>{paragraph}</p>
          ))}
          </Paragraph>
        )}
      </TextWrapper>
    </div>
  );
};